module.exports = __webpack_public_path__ + "img/poi-marker.0f1e4f2d.png";